import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f6028c7e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "overlay_setting"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loader_box" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "loader" }, "Loading...")
], -1))
const _hoisted_3 = [
  _hoisted_2
]


export default /*#__PURE__*/_defineComponent({
  __name: 'Loading',
  props: {
  isLoading: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const props = __props



return (_ctx: any,_cache: any) => {
  return (props.isLoading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
    : _createCommentVNode("", true)
}
}

})